import common_en_US from './en-US/common.json';
import dispatch_management_en_US from './en-US/dispatch_management.json';
import dsptch_reupload_en_US from './en-US/dsptch_reupload.json';
import dsptch_upload_file_preview_en_US from './en-US/dsptch_upload_file_preview.json';
import edit_dispatch_en_US from './en-US/edit_dispatch.json';
import new_dispatch_en_US from './en-US/new_dispatch.json';
import settings_en_US from './en-US/settings.json';
import common_es_CO from './es-CO/common.json';
import dispatch_management_es_CO from './es-CO/dispatch_management.json';
import dsptch_reupload_es_CO from './es-CO/dsptch_reupload.json';
import dsptch_upload_file_preview_es_CO from './es-CO/dsptch_upload_file_preview.json';
import edit_dispatch_es_CO from './es-CO/edit_dispatch.json';
import new_dispatch_es_CO from './es-CO/new_dispatch.json';
import settings_es_CO from './es-CO/settings.json';
import common_id_ID from './id-ID/common.json';
import dispatch_management_id_ID from './id-ID/dispatch_management.json';
import dsptch_reupload_id_ID from './id-ID/dsptch_reupload.json';
import dsptch_upload_file_preview_id_ID from './id-ID/dsptch_upload_file_preview.json';
import edit_dispatch_id_ID from './id-ID/edit_dispatch.json';
import new_dispatch_id_ID from './id-ID/new_dispatch.json';
import settings_id_ID from './id-ID/settings.json';
import common_ja_JP from './ja-JP/common.json';
import dispatch_management_ja_JP from './ja-JP/dispatch_management.json';
import dsptch_reupload_ja_JP from './ja-JP/dsptch_reupload.json';
import dsptch_upload_file_preview_ja_JP from './ja-JP/dsptch_upload_file_preview.json';
import edit_dispatch_ja_JP from './ja-JP/edit_dispatch.json';
import new_dispatch_ja_JP from './ja-JP/new_dispatch.json';
import settings_ja_JP from './ja-JP/settings.json';
import common_ko_KR from './ko-KR/common.json';
import dispatch_management_ko_KR from './ko-KR/dispatch_management.json';
import dsptch_reupload_ko_KR from './ko-KR/dsptch_reupload.json';
import dsptch_upload_file_preview_ko_KR from './ko-KR/dsptch_upload_file_preview.json';
import edit_dispatch_ko_KR from './ko-KR/edit_dispatch.json';
import new_dispatch_ko_KR from './ko-KR/new_dispatch.json';
import settings_ko_KR from './ko-KR/settings.json';
import common_ms_MY from './ms-MY/common.json';
import dispatch_management_ms_MY from './ms-MY/dispatch_management.json';
import dsptch_reupload_ms_MY from './ms-MY/dsptch_reupload.json';
import dsptch_upload_file_preview_ms_MY from './ms-MY/dsptch_upload_file_preview.json';
import edit_dispatch_ms_MY from './ms-MY/edit_dispatch.json';
import new_dispatch_ms_MY from './ms-MY/new_dispatch.json';
import settings_ms_MY from './ms-MY/settings.json';
import common_th_TH from './th-TH/common.json';
import dispatch_management_th_TH from './th-TH/dispatch_management.json';
import dsptch_reupload_th_TH from './th-TH/dsptch_reupload.json';
import dsptch_upload_file_preview_th_TH from './th-TH/dsptch_upload_file_preview.json';
import edit_dispatch_th_TH from './th-TH/edit_dispatch.json';
import new_dispatch_th_TH from './th-TH/new_dispatch.json';
import settings_th_TH from './th-TH/settings.json';
import common_vi_VN from './vi-VN/common.json';
import dispatch_management_vi_VN from './vi-VN/dispatch_management.json';
import dsptch_reupload_vi_VN from './vi-VN/dsptch_reupload.json';
import dsptch_upload_file_preview_vi_VN from './vi-VN/dsptch_upload_file_preview.json';
import edit_dispatch_vi_VN from './vi-VN/edit_dispatch.json';
import new_dispatch_vi_VN from './vi-VN/new_dispatch.json';
import settings_vi_VN from './vi-VN/settings.json';
import common_zh_CHS from './zh-CHS/common.json';
import dispatch_management_zh_CHS from './zh-CHS/dispatch_management.json';
import dsptch_reupload_zh_CHS from './zh-CHS/dsptch_reupload.json';
import dsptch_upload_file_preview_zh_CHS from './zh-CHS/dsptch_upload_file_preview.json';
import edit_dispatch_zh_CHS from './zh-CHS/edit_dispatch.json';
import new_dispatch_zh_CHS from './zh-CHS/new_dispatch.json';
import settings_zh_CHS from './zh-CHS/settings.json';
import common_zh_CHT from './zh-CHT/common.json';
import dispatch_management_zh_CHT from './zh-CHT/dispatch_management.json';
import dsptch_reupload_zh_CHT from './zh-CHT/dsptch_reupload.json';
import dsptch_upload_file_preview_zh_CHT from './zh-CHT/dsptch_upload_file_preview.json';
import edit_dispatch_zh_CHT from './zh-CHT/edit_dispatch.json';
import new_dispatch_zh_CHT from './zh-CHT/new_dispatch.json';
import settings_zh_CHT from './zh-CHT/settings.json';

const DispatchLanguage = {
    'en-US': {
        ...common_en_US,
        ...dispatch_management_en_US,
        ...edit_dispatch_en_US,
        ...new_dispatch_en_US,
        ...dsptch_reupload_en_US,
        ...dsptch_upload_file_preview_en_US,
        ...settings_en_US
    },

    'es-CO': {
        ...common_es_CO,
        ...dispatch_management_es_CO,
        ...edit_dispatch_es_CO,
        ...new_dispatch_es_CO,
        ...dsptch_reupload_es_CO,
        ...dsptch_upload_file_preview_es_CO,
        ...settings_es_CO
    },

    'id-ID': {
        ...common_id_ID,
        ...dispatch_management_id_ID,
        ...edit_dispatch_id_ID,
        ...new_dispatch_id_ID,
        ...dsptch_reupload_id_ID,
        ...dsptch_upload_file_preview_id_ID,
        ...settings_id_ID
    },

    'ja-JP': {
        ...common_ja_JP,
        ...dispatch_management_ja_JP,
        ...edit_dispatch_ja_JP,
        ...new_dispatch_ja_JP,
        ...dsptch_reupload_ja_JP,
        ...dsptch_upload_file_preview_ja_JP,
        ...settings_ja_JP
    },

    'ko-KR': {
        ...common_ko_KR,
        ...dispatch_management_ko_KR,
        ...edit_dispatch_ko_KR,
        ...new_dispatch_ko_KR,
        ...dsptch_reupload_ko_KR,
        ...dsptch_upload_file_preview_ko_KR,
        ...settings_ko_KR
    },

    'ms-MY': {
        ...common_ms_MY,
        ...dispatch_management_ms_MY,
        ...edit_dispatch_ms_MY,
        ...new_dispatch_ms_MY,
        ...dsptch_reupload_ms_MY,
        ...dsptch_upload_file_preview_ms_MY,
        ...settings_ms_MY
    },

    'th-TH': {
        ...common_th_TH,
        ...dispatch_management_th_TH,
        ...edit_dispatch_th_TH,
        ...new_dispatch_th_TH,
        ...dsptch_reupload_th_TH,
        ...dsptch_upload_file_preview_th_TH,
        ...settings_th_TH
    },

    'vi-VN': {
        ...common_vi_VN,
        ...dispatch_management_vi_VN,
        ...edit_dispatch_vi_VN,
        ...new_dispatch_vi_VN,
        ...dsptch_reupload_vi_VN,
        ...dsptch_upload_file_preview_vi_VN,
        ...settings_vi_VN
    },

    'zh-CHS': {
        ...common_zh_CHS,
        ...dispatch_management_zh_CHS,
        ...edit_dispatch_zh_CHS,
        ...new_dispatch_zh_CHS,
        ...dsptch_reupload_zh_CHS,
        ...dsptch_upload_file_preview_zh_CHS,
        ...settings_zh_CHS
    },

    'zh-CHT': {
        ...common_zh_CHT,
        ...dispatch_management_zh_CHT,
        ...edit_dispatch_zh_CHT,
        ...new_dispatch_zh_CHT,
        ...dsptch_reupload_zh_CHT,
        ...dsptch_upload_file_preview_zh_CHT,
        ...settings_zh_CHT
    }
};

export default DispatchLanguage;
